import React from 'react';

const steps = [
  {
    n:'01', c:'red',
    title:'Student Collaboration Focus',
    body:'Dedicated task force on the engagement to uplift students at every step.',
    svg:<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M17 20v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke="#FF0032" strokeWidth="1.5" strokeLinecap="round"/><circle cx="9" cy="7" r="4" stroke="#FF0032" strokeWidth="1.5"/><path d="M23 20v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" stroke="#FF0032" strokeWidth="1.5" strokeLinecap="round"/></svg>,
  },
  {
    n:'02', c:'blue',
    title:'Campus-Centric Planning',
    body:'Focus on premises-based activities directly linked to campus sessions.',
    svg:<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" stroke="#0583F2" strokeWidth="1.5" strokeLinecap="round"/><path d="M9 22V12h6v10" stroke="#0583F2" strokeWidth="1.5" strokeLinecap="round"/></svg>,
  },
  {
    n:'03', c:'red',
    title:'Concept-to-Execution Support',
    body:'Concept creation with hands-on delivery support from start to finish.',
    svg:<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="3" stroke="#FF0032" strokeWidth="1.5"/><path d="M12 2v3M12 19v3M4.22 4.22l2.12 2.12M17.66 17.66l2.12 2.12M2 12h3M19 12h3M4.22 19.78l2.12-2.12M17.66 6.34l2.12-2.12" stroke="#FF0032" strokeWidth="1.5" strokeLinecap="round"/></svg>,
  },
  {
    n:'04', c:'blue',
    title:'Strategic Event Consultation',
    body:'Aligned with the college\'s objectives in every sensible manner possible.',
    svg:<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" stroke="#0583F2" strokeWidth="1.5" strokeLinecap="round"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" stroke="#0583F2" strokeWidth="1.5" strokeLinecap="round"/></svg>,
  },
  {
    n:'05', c:'red',
    title:'Detail-Oriented Coordination',
    body:'Up-to-date plans and documentation for every incoming and outgoing task.',
    svg:<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><polyline points="9 11 12 14 22 4" stroke="#FF0032" strokeWidth="1.5" strokeLinecap="round"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" stroke="#FF0032" strokeWidth="1.5" strokeLinecap="round"/></svg>,
  },
];

export default function Approach() {
  return (
    <section id="approach" className="section bg-dark">
      <div className="max-w-content mx-auto">

        {/* Header */}
        <div className="text-center max-w-xl mx-auto mb-16 reveal">
          <span className="label label-red">Methodology</span>
          <h2 className="heading mt-5">Our <em>Approach</em></h2>
          <div className="divider center wide mt-5 mb-5" />
          <p className="subtext text-sm">
            Comprehensive solutions tailored to your campus needs — five steps, one goal.
          </p>
        </div>

        {/* Steps grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {steps.map((s, i) => (
            <div key={s.n}
              className={`card card-dark relative overflow-hidden p-7 ${s.c === 'red' ? 'red-hover' : 'blue-hover'} reveal d${i+1}`}>
              {/* Watermark */}
              <span className="step-num">{s.n}</span>

              {/* Icon */}
              <div className={`icon-box ${s.c} mb-5 mt-1 relative z-10`}>{s.svg}</div>

              {/* Step badge */}
              <span className={`label label-${s.c} text-[10px] mb-3 relative z-10`}>Step {s.n}</span>

              <h4 className="text-white font-bold text-sm leading-snug mb-2 relative z-10">{s.title}</h4>
              <p className="text-white/42 text-xs leading-relaxed relative z-10">{s.body}</p>

              {/* Bottom accent line */}
              <div className="absolute bottom-0 left-0 right-0 h-[2px] opacity-0 group-hover:opacity-100 transition-opacity"
                style={{ background: s.c === 'red' ? 'var(--red)' : 'var(--blue)' }} />
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
